/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */


import React from 'react';

import Utils from '../utils/Utils';

/**
 * Application Router (entry point)
 * @param props
 */
module.exports = class Router extends React.Component {
    componentWillMount() {
        document.documentElement.className = '';
        if (Utils.isAAHDR()) {
            document.documentElement.classList.add('theme-air_and_head_done_right');
            document.title = 'Air & Heat Micro Sites';
        } else {
            document.documentElement.classList.add('theme-motili');
            if (Utils.isAIG()) {
                document.title = 'Motili For AIG Micro Sites';
            } else {
                document.title = 'Motili Micro Sites';
            }

        }
    }

    render() {
        return (
            <div style={styles.appContainer} >
                {this.props.children}
            </div>
        );
    }
};

const styles = {
    // appContainer: {},
    appContainer: {
        display: 'flex',
        width: '100vw',
        justifyContent: 'center'
    }
};



// WEBPACK FOOTER //
// ./src/app/components/Router.js